import React, { PureComponent } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Footer } from '../../../components/footer';
import SzHeader from '../../../components/szHeader';
import Qrcode from '../../../components/qrcode';
import Search from '../../../components/search';
import GwSearch from '../layout/gwSearch';
import Banner from '../layout/banner';
import {
    getRecruitListFromMoka,
    getRecruitLocationFromMoka,
    getRecruitZhiNengFromMoka,
} from '../../../../services/api';
import { formatTime } from '@ifeng-fe/container_channel/common/client/winter/utils/formatTime';
import { formatMokaLocations, formatMokaZhiNengs } from '@ifeng-fe/container_channel/common/client/winter/utils/utils';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';

/**
 * for this page
 */

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };
        state = {
            jobname: '',
            workplace: '不限',
            jobType: '不限',
            jobCategory: '不限',
            list: [],
            hasData: true,
            currentPage: 1,
            currentList: [],
            currentPageData: [],
            pageCount: 0,
            offset: 0,
            limit: 10,
            locationList: [],
            zhinengList: [],
        };

        async componentDidMount() {
            const name = this.props.content.name; // this.getId();

            if (name !== 'undefined') {
                this.setState({
                    jobname: name,
                });

                this.getList(name, 0);

                this.getLocationList();

                this.getZhiNengList();
            }
        }
        UNSAFE_componentWillMount() {
            const device = this.mos();

            if (device === 'mobile') {
                window.location.href = 'https://app.mokahr.com/m/apply/ifeng/7541#/home?_k=ki7nvf';
            }
        }

        getLocationList = async () => {
            const locationList = await getRecruitLocationFromMoka('social');

            if (locationList && locationList.data) {
                this.setState({
                    locationList: formatMokaLocations(locationList.data),
                });
            }
        };

        getZhiNengList = async () => {
            const zhiNengList = await getRecruitZhiNengFromMoka('social');

            if (zhiNengList && zhiNengList.data) {
                this.setState({
                    zhinengList: formatMokaZhiNengs(zhiNengList.data),
                });
            }
        };

        mos() {
            const ua = typeof navigator === 'object' ? navigator.userAgent : '';

            if (ua.match(/iphone|ipod/gi) || ua.match(/ipad/gi) || ua.match(/android/gi)) {
                return 'mobile';
            } else {
                return 'pc';
            }
        }
        getId = () => {
            const url = window.location.href;
            const urlParams = url.indexOf('recruit');
            const paraArray = url.substring(urlParams + 7);
            const searchInfo = this.trimSpace(paraArray.split('/'));

            if (searchInfo.length > 0) {
                return searchInfo[0];
            } else {
                return '';
            }
        };
        trimSpace = array => {
            for (let i = 0; i < array.length; i++) {
                if (array[i] === '' || array[i] === ' ' || array[i] === null || typeof array[i] === 'undefined') {
                    array.splice(i, 1);
                    i -= 1;
                }
            }

            return array;
        };
        getList = async (name, offset) => {
            const mokaParams = {
                mode: 'social',
                limit: this.state.limit,
                offset,
                commitment: 1,
                siteId: 7541,
                status: 'open',
            };

            if (name) {
                mokaParams.keyword = name;
            }

            // const queryString = Object.keys(mokaParams)
            //     .map(itemKey => `${itemKey}=${mokaParams[itemKey]}`)
            //     .join('&');
            const queryString = encodeURIComponent(JSON.stringify(mokaParams));
            const res = await getRecruitListFromMoka(queryString);

            if (res.code === 0) {
                const data = res.data.data;
                const total = res.data.total;

                if (data.length > 0) {
                    const listF = this.formatData(data);

                    const pageNum = Math.ceil(total / this.state.limit);

                    this.setState({
                        list: listF,
                        currentList: listF,
                        currentPageData: listF,
                        pageCount: pageNum,
                        hasData: true,
                        offset: listF.length,
                    });
                } else {
                    this.setState({
                        list: [],
                        currentList: [],
                        currentPageData: [],
                        pageCount: 0,
                        hasData: false,
                        currentPage: 0,
                    });
                }
            } else {
                console.error('获取数据失败');
            }
        };

        // 格式化数据
        formatData = data => {
            const newData = data.map((item, index) => ({
                jobId: item.id,
                jobTitle: item.title,
                jobType: item.commitment,
                jobDepart: (item.department && item.department.name) || '',
                jobAddress:
                    (item.locations && item.locations[0] && item.locations[0].city) ||
                    (item.locations && item.locations[0] && item.locations[0].province) ||
                    '',
                jobKind: item.commitment,
                jobStarttime: formatTime(item.publishedAt),
                jobNum: item.number,
                jobKey: index,
            }));

            return newData;
        };
        handleName = text => {
            this.setState({
                jobname: text,
            });
            this.getSearchData(
                text,
                this.state.workplace,
                this.state.jobType,
                this.state.jobCategory,
                1,
                this.state.limit,
            );
        };
        handlePlace = text => {
            this.setState({
                workplace: text,
            });
            this.getSearchData(
                this.state.jobname,
                text,
                this.state.jobType,
                this.state.jobCategory,
                1,
                this.state.limit,
            );
        };
        handleType = text => {
            this.setState({
                jobType: text,
            });
            this.getSearchData(
                this.state.jobname,
                this.state.workplace,
                text,
                this.state.jobCategory,
                1,
                this.state.limit,
            );
        };
        handleCategory = text => {
            this.setState({
                jobCategory: text,
            });
            this.getSearchData(this.state.jobname, this.state.workplace, this.state.jobType, text, 1, this.state.limit);
        };
        pageView(num, current) {
            const topList = [];

            if (num <= 6) {
                for (let i = 1; i <= num; i++) {
                    topList.push(
                        <button
                            key={i}
                            className={i === current ? styles.current : ''}
                            onClick={() => this.getCurrentPageData(i)}>
                            {i}
                        </button>,
                    );
                }
            } else {
                const lastNum = num - 2;
                const lastFirstNum = num - 5;

                if (current <= 4) {
                    for (let i = 1; i <= 6; i++) {
                        topList.push(
                            <button
                                key={i}
                                className={i === current ? styles.current : ''}
                                onClick={() => this.getCurrentPageData(i)}>
                                {i}
                            </button>,
                        );
                    }
                } else if (current >= lastNum) {
                    for (let i = lastFirstNum; i <= num; i++) {
                        topList.push(
                            <button
                                key={i}
                                className={i === current ? styles.current : ''}
                                onClick={() => this.getCurrentPageData(i)}>
                                {i}
                            </button>,
                        );
                    }
                } else {
                    const begin = current - 3;
                    const end = current + 2;

                    for (let i = begin; i <= end; i++) {
                        topList.push(
                            <button
                                key={i}
                                className={i === current ? styles.current : ''}
                                onClick={() => this.getCurrentPageData(i)}>
                                {i}
                            </button>,
                        );
                    }
                }
            }

            return topList;
        }
        handleFirst = () => {
            this.getCurrentPageData(1);
        };
        // 上一页
        handlePagePre = () => {
            const current = this.state.currentPage;

            if (current === 1) {
                alert('已经是第一页了');
            } else {
                // ;
                this.getCurrentPageData(current - 1);
            }
        };
        handlePageNext = () => {
            const current = this.state.currentPage;
            const count = this.state.pageCount;

            if (current === count) {
                alert('已经是最后一页');
            } else {
                // ;
                this.getCurrentPageData(current + 1);
            }
        };
        handleLast = () => {
            this.getCurrentPageData(this.state.pageCount);
        };
        getSearchData = async (name, place, type, category, pageNo, pageSize) => {
            let params = {
                mode: 'social',
                limit: this.state.limit,
                // offset: pageNo === 1 ? 0 : this.state.offset,
                offset: (pageNo - 1) * pageSize,
                commitment: 1,
                siteId: 7541,
                status: 'open',
            };

            if (name) {
                params.keyword = name;
            }

            if (place && place !== '不限') {
                params.locationIds = JSON.stringify([place]);
            }

            if (category) {
                params.zhinengId = category;
            }

            // JSON.stringify
            params = encodeURIComponent(JSON.stringify(params));
            const searchList = await getRecruitListFromMoka(params);
            let listF = [];

            if (searchList.code === 0) {
                const data = searchList.data.data;
                const total = searchList.data.total;

                if (data.length > 0) {
                    listF = this.formatData(data);
                    const pageNum = Math.ceil(total / this.state.limit);

                    this.setState({
                        currentList: listF,
                        pageCount: pageNum,
                        currentPageData: listF,
                        hasData: true,
                        currentPage: pageNo,
                        offset: (pageNo - 1) * pageSize + listF.length,
                    });
                } else {
                    this.setState({
                        currentList: [],
                        pageCount: 0,
                        currentPageData: [],
                        hasData: false,
                        currentPage: 0,
                    });
                }
            } else {
                console.error('获取数据失败');
            }

            return listF;
        };
        getCurrentPageData = num => {
            if (num !== this.state.currentPage) {
                const pageData = this.getSearchData(
                    this.state.jobname,
                    this.state.workplace,
                    this.state.jobType,
                    this.state.jobCategory,
                    num,
                    this.state.limit,
                );

                this.setState({
                    currentPageData: pageData,
                    currentPage: num,
                });
            }
        };

        render() {
            const { content } = this.props;

            const { header, qrCodeInfo, banner } = content;
            const { jobname, hasData, currentPageData, currentPage, pageCount, locationList, zhinengList } = this.state;

            const gwTable =
                currentPageData && currentPageData.map
                    ? currentPageData.map((item, index) => {
                          return (
                              <tr key={index}>
                                  <td>{item.jobTitle}</td>

                                  <td>{item.jobDepart}</td>
                                  <td>{item.jobAddress}</td>
                                  <td>{item.jobType}</td>
                                  <td>{item.jobStarttime}</td>
                                  <td>
                                      <a className={styles.sqgw} href={`/job/detail/recruit/${item.jobId}/`}>
                                          申请职位
                                      </a>
                                  </td>
                              </tr>
                          );
                      })
                    : '';

            return (
                <div>
                    <div className={styles.col}>
                        <Search handleName={this.handleName} value={jobname} />

                        <Chip id="110038" type="struct" title="社招导航" groupName="凤凰招聘" content={header}>
                            <SzHeader current={1} />
                        </Chip>
                        <Chip id="110039" type="struct" title="社招焦点图" groupName="凤凰招聘" content={banner}>
                            <Banner />
                        </Chip>
                        <GwSearch
                            locations={locationList}
                            zhinengList={zhinengList}
                            handlePlace={this.handlePlace}
                            handleType={this.handleType}
                            handleCategory={this.handleCategory}
                        />
                        <div className={`${styles.col_w1000} clearfix`}>
                            <div className={styles.planBox}>
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                    <tbody>
                                        <tr>
                                            <th>职位名称</th>
                                            <th width="18%">部门名称</th>
                                            <th width="12%">工作地点</th>
                                            <th width="12%">工作性质</th>
                                            <th width="18%">发布时间</th>
                                            <th width="15%">申请职位</th>
                                        </tr>
                                        {gwTable}
                                    </tbody>
                                </table>
                                {currentPageData.length ? (
                                    <div className={styles.next} style={{ textAlign: 'center' }}>
                                        <button onClick={this.handleFirst}> &lt;&lt; 首页</button>
                                        <button onClick={this.handlePagePre}> &lt;&lt; 上一页</button>
                                        {this.pageView(pageCount, currentPage)}
                                        <button className={styles.nextPage} onClick={this.handlePageNext}>
                                            下一页 &gt;&gt;
                                        </button>
                                        <button onClick={this.handleLast}>尾页 &gt;&gt; </button>
                                    </div>
                                ) : (
                                    <div className={styles.wgw} style={{ display: hasData ? 'none' : 'block' }}>
                                        暂无职位，敬请期待！
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Footer />
                    <Qrcode content={qrCodeInfo} />
                    <ChipEdit />
                </div>
            );
        }
    },
);

export { Layout };
export default Layout;
